var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3164,
    cy: 19,
    r: 19,
    fill: "#FCE5E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_2734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8844 25.052C30.6605 24.688 30.3929 24.3425 30.1923 24.0074C29.9149 23.544 29.6488 23.0732 29.3778 22.6062C28.6817 21.4074 27.9859 20.2083 27.2898 19.0095C25.8141 16.4674 24.3383 13.9252 22.8623 11.3831C22.3965 10.5806 21.9307 9.77815 21.4649 8.976C21.1199 8.38092 20.4911 8.00123 19.8063 8C19.7834 8 19.7601 8.00031 19.7372 8.00092C19.075 8.02215 18.4746 8.39908 18.1407 8.97446C18.0348 9.15692 17.929 9.33908 17.8232 9.52154C17.5394 10.0102 17.2558 10.4988 16.972 10.9874C16.561 11.6954 16.1499 12.4037 15.7388 13.1117C15.2507 13.9523 14.7626 14.7929 14.2748 15.6338C13.76 16.5203 13.2456 17.4068 12.7308 18.2932C12.2403 19.1385 11.7494 19.9837 11.2588 20.8289C10.8422 21.5462 10.426 22.2634 10.0094 22.9806C9.75373 23.4212 9.50538 23.8665 9.24878 24.3065C8.79826 25.0794 8.1202 25.8886 8.37252 26.848C8.56704 27.5886 9.25948 28 9.99351 28C9.99351 28 29.5864 28 29.6115 28C30.4323 28 31.1425 27.3969 31.2918 26.5858C31.3939 26.032 31.1762 25.5265 30.8844 25.052Z",
    fill: "#ED4337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9199 14.5215C18.9199 13.884 19.4337 13.3677 20.0668 13.3677C20.7 13.3677 21.2138 13.884 21.2138 14.5215V19.9061C21.2138 20.5431 20.7 21.06 20.0668 21.06C19.4337 21.06 18.9199 20.5431 18.9199 19.9061V14.5215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0737 24.9123C20.7071 24.9123 21.2206 24.3957 21.2206 23.7585C21.2206 23.1212 20.7071 22.6046 20.0737 22.6046C19.4403 22.6046 18.9268 23.1212 18.9268 23.7585C18.9268 24.3957 19.4403 24.9123 20.0737 24.9123Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_2734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 20,
    fill: "white",
    transform: "translate(8.31641 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationWarning);
export default __webpack_public_path__ + "static/media/notification_warning.ff79d25f4782c6372e66b0c3bb38292e.svg";
export { ForwardRef as ReactComponent };